import moment from 'moment';

/********** Private properties **********/

var names = "";


/********** Public functions **********/

export function ordinalSuffixOf(i) {
    var j = i % 10;
    var k = i % 100;

    if (j === 1 && k !== 11) {
        return i + "st";
    }
    if (j === 2 && k !== 12) {
        return i + "nd";
    }
    if (j === 3 && k !== 13) {
        return i + "rd";
    }
    return i + "th";
}

export function formatDisplayDateTime(dateTime) {
    if (!moment(dateTime).isValid()) {
        return "";
    }

    const datestyleAmerican = true;
    var locale = "";

    // Get locale formatting
    if (datestyleAmerican) {
        locale = moment(dateTime).format('M/D/YYYY h:mm:ss a');
    } else {
        locale = moment(dateTime).format('YYYY-M-D h:mm:ss a');
    }
    return locale;
}

// Input type="date" format: YYYY-MM-DD
export function formatInputDate(dateTime) {
    var notUTC = false;
    if (typeof dateTime === "string") {
        notUTC = true;
    }

    // console.log(`formatInputDate(${dateTime})  checkDateTime(${dateTime}) => ${checkDateTime(dateTime)}  `);
    dateTime = checkDateTime(dateTime);
    if (dateTime == null) {
        return "";
    }

    if (!moment(dateTime).isValid()) {
        return "";
    }


    // console.log(`formatInputDate(${dateTime})  utc = ${moment(dateTime).utc().format('YYYY-MM-DD')}    tz = ${moment(dateTime).format('YYYY-MM-DD')}    old return value = ${dt} `);
    if (notUTC) {
        return moment(dateTime).format('YYYY-MM-DD');
    } else {
        return moment(dateTime).utc().format('YYYY-MM-DD');
    }
}

// Input type="time" format: HH:mm
export function formatInputTime(dateTime) {
    var notUTC = false;
    if (typeof dateTime === "string") {
        notUTC = true;
    }
    dateTime = checkDateTime(dateTime);
    if (dateTime == null) {
        return "";
    }

    const hours = getHours(dateTime, notUTC);
    const minutes = getMinutes(dateTime, notUTC);

    return hours + ":" + minutes;
}

// Input type="duration" format: HH:mm:ss
export function formatHm(durationSecs) {
    let hours = 0;
    let minutes = 0;

    if (/(\d\d*):(\d\d*)/.test(durationSecs)) {
        hours = parseInt(RegExp.$1, 10) % 100;
        minutes = parseInt(RegExp.$2, 10) % 60;
    } else {
        hours = parseInt(parseInt(durationSecs, 10) / 3600, 10) % 60;
        minutes = parseInt(parseInt(durationSecs, 10) / 60, 10) % 60;
    }

    if (hours < 10) {
        hours = "0" + hours;
    }
    if (minutes < 10) {
        minutes = "0" + minutes;
    }

    return hours + ":" + minutes;
}

export function formatHms(durationSecs) {
    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    if (/(\d\d*):(\d\d*):(\d\d*)/.test(durationSecs)) {
        hours = parseInt(RegExp.$1, 10) % 100;
        minutes = parseInt(RegExp.$2, 10) % 60;
        seconds = parseInt(RegExp.$3, 10) % 60;
    } else {
        hours = parseInt(parseInt(durationSecs, 10) / 3600, 10) % 60;
        minutes = parseInt(parseInt(durationSecs, 10) / 60, 10) % 60;
        seconds = parseInt(durationSecs, 10) % 60;
    }

    if (hours < 10) {
        hours = "0" + hours;
    }
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    if (seconds < 10) {
        seconds = "0" + seconds;
    }

    return hours + ":" + minutes + ":" + seconds;
}

export function getDurationFromHm(hmsStr) {
    let hours = 0;
    let minutes = 0;

    if (/(\d\d*):(\d\d*)/.test(hmsStr)) {
        hours = parseInt(RegExp.$1, 10) % 100;
        minutes = parseInt(RegExp.$2, 10) % 60;
    } else {
        let durationSecs = parseInt(hmsStr, 10);
        if (isNaN(durationSecs)) {
            durationSecs = 0;
        }
        hours = parseInt(parseInt(durationSecs, 10) / 3600, 10) % 60;
        minutes = parseInt(parseInt(durationSecs, 10) / 60, 10) % 60;
    }
    return (hours * 3600 + minutes * 60);
}


export function getDurationFromHms(hmsStr) {
    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    if (/(\d\d*):(\d\d*):(\d\d*)/.test(hmsStr)) {
        hours = parseInt(RegExp.$1, 10) % 100;
        minutes = parseInt(RegExp.$2, 10) % 60;
        seconds = parseInt(RegExp.$3, 10) % 60;
    } else {
        let durationSecs = parseInt(hmsStr, 10);
        if (isNaN(durationSecs)) {
            durationSecs = 0;
        }
        hours = parseInt(parseInt(durationSecs, 10) / 3600, 10) % 60;
        minutes = parseInt(parseInt(durationSecs, 10) / 60, 10) % 60;
        seconds = parseInt(durationSecs, 10) % 60;
    }
    return (hours * 3600 + minutes * 60 + seconds);
}

export function formatStudySiteName(studySite) {
    var name = "";
    if (studySite != null &&
        studySite.site != null &&
        studySite.study != null) {
        name = `${studySite.study.name}/${studySite.site.name}`;
    }
    return name;
}

// ISO-8601 standard: YYYY-MM-DDTHH:mm:ss.sssZ
// Input type="date" format: YYYY-MM-DD
export function getDateTimeFromInputDate(date, currentDateTime) {
    var hours = "00";
    var milliseconds = "000";
    var minutes = "00";
    var seconds = "00";

    currentDateTime = checkDateTime(currentDateTime);
    if (currentDateTime != null) {
        hours = getHours(currentDateTime);
        milliseconds = getMilliseconds(currentDateTime);
        minutes = getMinutes(currentDateTime);
        seconds = getSeconds(currentDateTime);
    }

    const dateString = date + "T" + hours + ":" + minutes + ":" + seconds + "." + milliseconds + "Z";
    return getDateTimeFromDateString(dateString);
}

// ISO-8601 standard: YYYY-MM-DDTHH:mm:ss.sssZ
// Input type="time" format: HH:mm
export function getDateTimeFromInputTime(time, currentDateTime) {
    currentDateTime = checkDateTime(currentDateTime);
    if (currentDateTime == null) {
        currentDateTime = new Date();
    }

    const dateString = formatInputDate(currentDateTime) + "T" + time + ":00.000Z";
    return getDateTimeFromDateString(dateString);
}

export function getDateTimeJson(dateTime) {
    if (dateTime == null) {
        return null;
    }

    if (typeof dateTime === "string") {
        if (!dateTime.endsWith("Z")) {
            dateTime += ".000Z";
        }
        return dateTime;
    }

    const dateObject = getUtcDateTime(dateTime, true);
    const date = formatInputDate(dateObject);
    const time = formatInputTime(dateObject);

    // Return in UTC format/ISO-8601 standard: YYYY-MM-DDTHH:mm:ss.sssZ
    const dt = date + "T" + time + ":00.000Z";
    // console.log(`getDateTimeJson(${dateTime})  previous = ${dt}    mom = ${moment(dateTime).toISOString()} `);
    return dt;
}

export function getNamesFromArray(array) {
    names = "";
    if (array != null) {
        array.forEach(makeNames);
    }
    return names;
}

export function getTimeZone() {
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;    // Gives "America/Chicago"
    const timeZoneAbbreviation = new Date().toString().match(/\(([+\-A-Za-z\s].*)\)/)[1];  // Gives "Central Daylight Time"
    if (timeZoneAbbreviation != null) {
        timeZone += "/" + timeZoneAbbreviation;
    }

    return timeZone;
}

export function getTimeZoneOffset() {
    return new Date().getTimezoneOffset();
}

export function propCheck(prop, current) {
    if (prop != null) {
        current = prop;
    }
    return current;
}

export function translateBool(value) {
    if (value) {
        return "Yes";
    }
    return "No";
}


export function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
        return v.toString(16);
    }
    );
}


/********** Private functions **********/

function checkDateTime(dateTime) {
    if (dateTime == null ||
        dateTime === "") {
        return null;
    }
    if (typeof dateTime === "string") {
        dateTime = getDateTimeFromDateString(dateTime);
        if (dateTime == null) {
            return null;
        }
    }
    return dateTime;
}

function getDateTimeFromDateString(dateString, doNotAppend) {
    if ((doNotAppend == null ||
        !doNotAppend) &&
        !dateString.endsWith("Z")) {
        if (!dateString.includes(".")) {
            dateString += ".000";
        }
        dateString += "Z";
    }
    var dateTime = new Date(dateString);
    if (!isValidDateTime(dateTime)) {
        dateTime = null;
    }
    // console.log(`getDateTimeFromDateString(${dateString})  old = ${dateTime}    mom = ${new Date(moment(dateString).toISOString())} `);
    return dateTime;
}


function getHours(dateTime, notUTC) {
    var hours = dateTime.getUTCHours();
    if (notUTC) {
        hours = dateTime.getHours();
    }
    if (hours < 10) {
        hours = "0" + hours;
    }
    return hours;
}

function getMilliseconds(dateTime, notUTC) {
    var milliseconds = dateTime.getUTCMilliseconds();
    if (notUTC) {
        milliseconds = dateTime.getMilliseconds();
    }
    if (milliseconds < 100) {
        if (milliseconds < 10) {
            milliseconds = "00" + milliseconds;
        }
        else {
            milliseconds = "0" + milliseconds;
        }
    }
    return milliseconds;
}

function getMinutes(dateTime, notUTC) {
    var minutes = dateTime.getUTCMinutes();
    if (notUTC) {
        minutes = dateTime.getMinutes();
    }
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    return minutes;
}

function getSeconds(dateTime, notUTC) {
    var seconds = dateTime.getUTCSeconds();
    if (notUTC) {
        seconds = dateTime.getSeconds();
    }
    if (seconds < 10) {
        seconds = "0" + seconds;
    }
    return seconds;
}

function getUtcDateTime(dateTime, doNotAppend) {
    const date = formatInputDate(dateTime);
    const time = formatInputTime(dateTime);

    var dateString = date + "T" + time;
    if (doNotAppend == null ||
        !doNotAppend) {
        dateString += ":00.000Z";
    }

    return getDateTimeFromDateString(dateString, doNotAppend);
}

function isValidDateTime(dateTime) {
    return dateTime instanceof Date && !isNaN(dateTime);
}

function makeNames(value, index, array) {
    var comma = ", ";
    if (index === array.length - 1) {
        comma = "";
    }
    if (value.name != null) {
        names = names + value.name + comma;
    }
}


// WEBPACK FOOTER //
// ./src/data/Utility.js